import {applySpec, flow, stubString, toDefaultEmptyString} from '@yandex-delivery/utils'

import type {Offer, OfferFailureBlock} from '../../../model/offer'
import type {OfferFailureBlock as ResponseOfferFailureBlock, OffersCalculateResponseV2} from '../../../repo/dcaa'
import {offerGetter, offersCalculateGetter} from '../../../repo/dcaa/getters/offers-calculate-getter'

const getOffers = offersCalculateGetter('claims_offers')
const getFailureBlocks = offersCalculateGetter('offer_failure_blocks')

const getId = offerGetter('payload')
const getPrice = offerGetter('price.total_price')
const getPriceVAT = offerGetter('price.total_price_with_vat')
const getSurgeRatio = offerGetter('price.surge_ratio')
const getDisableReason = offerGetter('failure_reason.message')
const getDisableReasonCode = offerGetter('failure_reason.code')
const getCurrency = offerGetter('price.currency')
const getVisitingIntervals = offerGetter('visiting_intervals')

const getTariff = offerGetter('tariff_info.tariff')
const getVertical = offerGetter('tariff_info.vertical')
const getTitle = flow(offerGetter('tariff_info.title'), toDefaultEmptyString)

const toOffer: (estimationResult: OffersCalculateResponseV2['claims_offers'][number]) => Offer = applySpec<Offer>({
  id: getId,
  title: getTitle,
  price: getPrice,
  priceVAT: getPriceVAT,
  surgeRatio: getSurgeRatio,
  tariff: getTariff,
  disableReason: getDisableReason,
  disableReasonCode: getDisableReasonCode,
  currency: getCurrency,
  vertical: getVertical,
  visitingIntervals: getVisitingIntervals,
  intervalCaption: stubString,
})

export function toBlocks(blocks: ResponseOfferFailureBlock[]): OfferFailureBlock[] {
  return blocks.map(block => {
    const details =
      (block.type === 'summarized' && block.summarized_info) ||
      (block.type === 'modal' && block.modal) ||
      (block.type === 'button' && block.button)

    return {
      type: block.type,
      failureReason: block.failure_reason,
      title: details?.title,
      subtitle: details?.subtitle,
    }
  })
}
export function fromOffersCalculateResponse(response: OffersCalculateResponseV2): Array<Offer> {
  const claimOffers = getOffers(response)
  const failureBlocks = getFailureBlocks(response)

  return claimOffers.map(offer => {
    const vertical = offer.tariff_info.vertical
    const blocks =
      vertical && failureBlocks[vertical] ? {offerFailureBlocks: toBlocks(failureBlocks[vertical]?.blocks)} : {}

    return Object.assign(toOffer(offer), blocks)
  })
}
